import {
  BreakpointQueryName, FontWeight, getSpacing, getTypography, SpacingName, ThemedFunctor, TypographyName,
} from '@doveit/lego';
import { css } from 'styled-components';

export const header: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.margin(theme, [SpacingName.BIG, 0, SpacingName.MEDIUM, 0])}
`;

export const title: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H3)}
`;

export const details: ThemedFunctor = ({ theme }) => css`
  display: flex;
  align-items: baseline;
  justify-content: flex-start;
  flex-wrap: wrap;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    flex-wrap: no-wrap;
  }
`;

export const info: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.BODY)}
  color: ${theme.palettes.neutrals.medium};
  margin-top: .5rem;
  width: 100%;

  span {
    display: block;
  }

  ${theme.breakpoints.up(BreakpointQueryName.SM)} {
    span {
      margin-right: 0.5rem;
      display: inline;

      &:last-of-type {
        margin-right: 0;
      }

      &:not(:last-of-type)::after {
        content: '-';
        margin-left: 0.5rem;
      }
    }
  }

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    width: auto;
  }
`;

export const categories: ThemedFunctor = () => css`
  display: flex;
  align-items: baseline;
`;

export const categoriesLabel: ThemedFunctor = ({ theme }) => css`
  white-space: nowrap;
  color: ${theme.palettes.neutrals.medium};
  margin-right: .5rem;
`;

export const divider: ThemedFunctor = ({
  theme,
}) => css`
 display: none;
 color: ${theme.palettes.neutrals.medium};
 ${getSpacing.padding(theme, [0, SpacingName.SMALLER])}

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    display: block;
  }
`;

export const relatedArticles: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.MEDIUM)}
`;

export const image: ThemedFunctor = ({
  theme,
}) => css`
  img {
    display: block;
  }
  ${getSpacing.marginBottom(theme, SpacingName.MEDIUM)}
`;

export const block: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.BIG)}
  position: relative;
`;

export const adv: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.marginTop(theme, SpacingName.MEDIUM)}
  ${getSpacing.padding(theme, [SpacingName.MEDIUM, SpacingName.SMALL])}
  background-color: ${theme.palettes.neutrals.lighter};
`;

export const advWrapper = css`
  max-width: 40rem;
  margin: 0 auto;
`;

export const share: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.margin(theme, [SpacingName.MEDIUM, 0, SpacingName.SMALL])}
  ${getTypography(theme, TypographyName.BODY)}
  font-weight: ${FontWeight.BOLD};
`;

export const summary: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.BIG)}
  ${getTypography(theme, TypographyName.BODY)}
`;

export const summaryTitle: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginBottom(theme, SpacingName.SMALL)}
  ${getTypography(theme, TypographyName.H4)}
`;

export const summaryList = css`
  padding-left: 1rem;
  list-style: disc;
  line-height: 1.7rem;
`;

export const footer: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.MEDIUM)}
`;
